import { render, staticRenderFns } from "./OTPComponent.vue?vue&type=template&id=8703b0a2&"
import script from "./OTPComponent.vue?vue&type=script&lang=js&"
export * from "./OTPComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports